import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useFaqsMaster } from "../../store/faq/reducer";
import { REQUEST_DELETE_MASTER_FAQS } from "../../store/faq/faqActionTypes";
import { useCuisinesMaster } from "../../store/cuisines/reducer";
import { REQUEST_DELETE_MASTER_CUISINES } from "../../store/cuisines/cuisineActionTypes";
interface CuisineDeleteProps {
  cuisineData?: any;
  isOpen: boolean;
  onClose: () => void;
}

const CuisineDeleteConfirmation: React.FC<CuisineDeleteProps> = ({
  isOpen,
  onClose,
  cuisineData,
}) => {
  const dispatch = useDispatch();
  const { masterCuisines: events, busy, message } = useCuisinesMaster();
  const toast = useToast();
  useEffect(() => {
    const findEvent = events.find(
      (val: Record<string, any>) => val._id === cuisineData._id
    );
    if (!findEvent) {
      toast({
        title: "Success.",
        description: "selected data is deleted.",
        status: "success",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [cuisineData, events, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Theme</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {`Are you sure you want to delete this theme?`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_CUISINES,
                payload: { _id: cuisineData._id },
              });
              onClose();
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CuisineDeleteConfirmation;
